import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { ORGANIZATION_CACHE_KEY } from "./keys";

import { applyDevOrgType } from "@/components/dev-tweaks/helpers";
import { isMockEnabled, simulateDelay } from "@/mock/config";
import { getOrganizationMock } from "@/mock/handlers/organization";
import { useGlobalStore } from "@/stores/global";
import { Organization } from "@/types/organization";
import { Response } from "@/types/pagination";
import { retryUnlessNotFound } from "@/utils/error";

import { api } from "@/lib/api-client";

export const useGetOrganization = () => {
  const setOrganization = useGlobalStore((state) => state.setOrganization);

  const query = useQuery({
    queryKey: [ORGANIZATION_CACHE_KEY],
    queryFn: async () => {
      if (isMockEnabled()) {
        await simulateDelay();

        return applyDevOrgType(getOrganizationMock());
      }

      const { data } = await api
        .get("organizations")
        .json<Response<Organization>>();

      return applyDevOrgType(data);
    },
    retry: retryUnlessNotFound,
  });

  useEffect(() => {
    if (query.data) {
      setOrganization(query.data);
    }
  }, [query.data, setOrganization]);

  return query;
};
